// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"9b8fdd14","554":"dd5fc146"}[chunkId] + ".chunk.css";
};